<template>
    <CardPage :section="4" :page="page" :audio="audio">
        <v-container fluid pa-0>
            <v-layout row wrap justify-space-between>
                <v-flex xs12>
                    <p class="headline text-xs-center">{{ houseGoal.title }}</p>
                </v-flex>
                <v-flex xs5>
                    <ResponsiveImage :src="houseGoal.image" :alt="houseGoal.character" layout="" flex="" :min-height="200" :max-height="325"></ResponsiveImage>
                </v-flex>
                <v-flex xs6>
                    <p>{{ houseGoal.text }}</p>
                </v-flex>
            </v-layout>
        </v-container>
    </CardPage>
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            required: true
        },
        goal: {
            type: Number,
            required: true
        },
        audio: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        houseGoal() {
            return this.$store.get(`section4/goals@${this.goal}`);
        }
    }
};
</script>
